module.exports = __webpack_public_path__ + "img/zebra-circle.47bcb439.png";